import Image from 'next/image';
import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
import { handleImageError } from '@/utils/image-error';
import usePDPData from '../../_utils/use-pdp-data';
import { useVariantContextValues } from '../../context/use-variant-context-values';
const BuyBoxPhoto = () => {
  const {
    data
  } = usePDPData();
  const {
    activeVariant
  } = useVariantContextValues('pdp');
  const mainImage = activeVariant?.color?.images?.at(0)?.imageUrl || data?.mainImageUrl;
  return <>
            <span className='text-center text-body-16 font-medium text-text-black'>
                {data?.nameFa} {data?.brand?.nameFa}
            </span>
            {mainImage && <Image src={`${mainImage}?w=96`} alt={data?.nameFa + ' ' + data?.brand?.nameFa} className='mx-auto aspect-square h-[96px] rounded shadow' width={96} height={96} unoptimized onError={handleImageError} loading={PUBLIC_IS_BOT ? undefined : 'lazy'} />}
        </>;
};
export default BuyBoxPhoto;